import React from 'react';
import { MapPinIcon, EyeIcon, CalendarIcon, TrashIcon, EditIcon } from 'lucide-react';
import { Listing, LISTING_TYPE_LABELS } from '../types';
interface ListingCardProps {
  listing: Listing;
  showActions?: boolean;
  onDelete?: (id: string) => void;
  onEdit?: (listing: Listing) => void;
}
const typeColors: Record<string, string> = {
  service: 'bg-orange-100 text-orange-700',
  good: 'bg-blue-100 text-blue-700',
  product: 'bg-green-100 text-green-700',
  event: 'bg-red-100 text-red-700',
  news: 'bg-purple-100 text-purple-700'
};
export function ListingCard({
  listing,
  showActions,
  onDelete,
  onEdit
}: ListingCardProps) {
  return <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-190">
      <div className="relative h-40 overflow-hidden" data-id="element-191">
        <img src={listing.image} alt={listing.title} className="w-full h-full object-cover" data-id="element-192" />
        <div className="absolute top-2 right-2" data-id="element-193">
          <span className={`px-2 py-1 rounded text-xs font-medium ${typeColors[listing.type]}`} data-id="element-194">
            {LISTING_TYPE_LABELS[listing.type]}
          </span>
        </div>
      </div>

      <div className="p-4" data-id="element-195">
        <h3 className="font-semibold text-gray-900 mb-2 line-clamp-1" data-id="element-196">
          {listing.title}
        </h3>
        <p className="text-sm text-gray-600 mb-3 line-clamp-2" data-id="element-197">
          {listing.description}
        </p>

        <div className="flex items-center justify-between text-xs text-gray-500 mb-3" data-id="element-198">
          <div className="flex items-center space-x-1" data-id="element-199">
            <MapPinIcon className="w-3 h-3" data-id="element-200" />
            <span data-id="element-201">{listing.location}</span>
          </div>
          <div className="flex items-center space-x-1" data-id="element-202">
            <EyeIcon className="w-3 h-3" data-id="element-203" />
            <span data-id="element-204">{listing.views}</span>
          </div>
        </div>

        {listing.eventDate && <div className="flex items-center space-x-1 text-xs text-gray-500 mb-3" data-id="element-205">
            <CalendarIcon className="w-3 h-3" data-id="element-206" />
            <span data-id="element-207">
              {listing.eventDate}{' '}
              {listing.eventTime && `at ${listing.eventTime}`}
            </span>
          </div>}

        {listing.price !== undefined && listing.price > 0 && <div className="text-lg font-bold text-green-600 mb-3" data-id="element-208">
            KES {listing.price.toLocaleString()}
          </div>}

        {showActions && <div className="flex space-x-2 pt-2 border-t" data-id="element-209">
            <button onClick={() => onEdit?.(listing)} className="flex-1 flex items-center justify-center space-x-1 py-2 text-sm text-blue-600 hover:bg-blue-50 rounded transition-colors" data-id="element-210">
              <EditIcon className="w-4 h-4" data-id="element-211" />
              <span data-id="element-212">Edit</span>
            </button>
            <button onClick={() => onDelete?.(listing.id)} className="flex-1 flex items-center justify-center space-x-1 py-2 text-sm text-red-600 hover:bg-red-50 rounded transition-colors" data-id="element-213">
              <TrashIcon className="w-4 h-4" data-id="element-214" />
              <span data-id="element-215">Delete</span>
            </button>
          </div>}
      </div>
    </div>;
}